
var show = function (el) {
    var btn = el.querySelector('[data-show-btn]'),
        toggle = function(){
            el.classList.toggle('js-active');
        };

    //
    btn.addEventListener('click', toggle);
};

export {show};